export default "__VITE_ASSET__Cs_0vnEp__"